import type {AppDispatch, GetStateFunc} from "../store";
import {ActionUtil} from "./ActionUtil";
import {ApiUtil} from "../api/ApiUtil";
import {BackendAPI} from "../api/BackendAPI";
import type {ServicePricesResponse} from "../api/types";

export enum ServicePriceActionType {
  SERVICE_PRICES_PENDING = 'SERVICE_PRICES_PENDING',
  SERVICE_PRICES_FULFILLED = 'SERVICE_PRICES_FULFILLED',
  SERVICE_PRICES_REJECTED = 'SERVICE_PRICES_REJECTED',
}

interface FetchServicePricesAction {
  type: ServicePriceActionType.SERVICE_PRICES_PENDING
}

interface FetchServicePricesSuccessAction {
  type: ServicePriceActionType.SERVICE_PRICES_FULFILLED,
  payload: {
    hydrolinkApiPrice: number
    hydrolinkPremiumPrice: number,
    vatMultiplier: number
  }
}

interface FetchServicePricesFailureAction {
  type: ServicePriceActionType.SERVICE_PRICES_REJECTED,
  payload: {
    error: string
  }
}

export type ServicePriceAction =
  | FetchServicePricesAction
  | FetchServicePricesSuccessAction
  | FetchServicePricesFailureAction

export function fetchServicePrices() {
  return async (dispatch: AppDispatch, getState: GetStateFunc) => {
    const token = ActionUtil.getToken(getState, 'createReport')
    if (!token) {
      return
    }

    dispatch<ServicePriceAction>(servicePricesPending())
    const servicePricesRes = await BackendAPI.getServicePrices(token)
    if (servicePricesRes.succeeded) {
      dispatch(servicePricesSucceeded(servicePricesRes.payload))
    } else {
      const errMsg = ApiUtil.resolveLocalizedErrorMessage(servicePricesRes)
      dispatch(servicePricesFailed(errMsg))
    }
  }
}

/* Helper Functions */

function servicePricesPending(): ServicePriceAction {
  return {type: ServicePriceActionType.SERVICE_PRICES_PENDING}
}

function servicePricesFailed(error: string): ServicePriceAction {
  return {type: ServicePriceActionType.SERVICE_PRICES_REJECTED, payload: {error}}
}

function servicePricesSucceeded(payload: ServicePricesResponse): ServicePriceAction {
  return {
    type: ServicePriceActionType.SERVICE_PRICES_FULFILLED,
    payload: {
      ...payload
    }
  }
}
